import type { Permission } from '@wix/app-market-services';

export const shouldShowPermissionsAndTerms = (
  permissions: Permission[],
  isInstalled: boolean,
) => {
  return Boolean(permissions && permissions.length > 0 && !isInstalled);
};
